abstract class ClientInterfaceAbstract {
  abstract onCompleted(message?: string): void;
  abstract onCancelled(message?: string): void;
  abstract onError(message?: string): void;
  abstract onSessionExpiry(message?: string): void;
}

export default ClientInterfaceAbstract;
